import { render } from "./GeNumber.vue?vue&type=template&id=3bf2a565"
import script from "./GeNumber.vue?vue&type=script&lang=js"
export * from "./GeNumber.vue?vue&type=script&lang=js"

import "./GeNumber.vue?vue&type=style&index=0&id=3bf2a565&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__